import React from 'react';
import {AMBIENTE_DESENVOLVIMENTO} from './apiAmbiente';
export default function FaixaAmbienteDesenvolvimento() {
  if(!AMBIENTE_DESENVOLVIMENTO)return null;
  return <div role="status" style={{position:'fixed',bottom:8,right:8,zIndex:12000,padding:'5px 10px',borderRadius:4,background:'#fff3cd',color:'#664d03',border:'1px solid #e0bb42',fontSize:12,pointerEvents:'none'}}>
    <strong>DESENVOLVIMENTO</strong> · API apidesenv
  </div>;
}
